import React, { useEffect } from 'react'
import AlertWaiting from '../../molecules/AlertWaiting'
import AlertError from '../../molecules/AlertError'
import ButtonOrange from '../../atoms/ButtonOrange'
import Modal from '../../molecules/ModalCadastro'
import TitleRoxo from '../../atoms/TitleRoxo'
import Footer from '../../molecules/Footer'
import Menu from '../../molecules/Menu'

import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useState } from 'react'

import { verificaLatitudeLongitude } from '../../../services/api'

import * as Styled from './styles'
import { loadAndTrackPixel } from '../../../services/pixel'
import { rastrear } from '../../../services/tracking'
import { useRastreioFormulario } from '../../../hooks/useRastreioFormulario'

export default function CadastroFinal() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()
  const history = useHistory()

  const [errorCadastroFinal, setErrorCadastroFinal] = useState(false)
  const [errorCep, setErrorCep] = useState(false)
  const [waiting, setWaiting] = useState(false)
  const [confirm, setConfirm] = useState(false)

  const [disabled, setDisabled] = useState(false)

  const [abrirModalCadastro] = useState(sessionStorage.getItem('open'))
  const [nomeLocal] = useState(localStorage.getItem('nomeCliente'))
  const [cpfOuCnpj] = useState(localStorage.getItem('CPFOUCNPJ'))

  const [modalidade, setModalidade] = useState('')
  const [modalidadeError, setModalidadeError] = useState(false)

  const [confirmacaoSenha, setConfirmacao] = useState('')
  const [validarSenha, setValidarSenha] = useState(false)
  const [showSenha, setShowSenha] = useState(false)
  const [showConfirmacao, setShowConfirmacao] = useState(false)
  const [redirectSeconds, setRedirectSeconds] = useState(3)
  const rastreio = useRastreioFormulario('passo2')

  const [resultLocation, setResultLocation] = useState('')
  const [logradouro, setLogradouro] = useState('')
  const [nomeEmpresa, setEmpresa] = useState('')
  const [cidade, setCidade] = useState('')
  const [bairro, setBairro] = useState('')
  const [estado, setEstado] = useState('')
  const [numero, setNumero] = useState('')
  const [senha, setSenha] = useState('')
  const [cep, setCep] = useState('')

  useEffect(() => {
    loadAndTrackPixel()
    if (!cpfOuCnpj) {
      history.push('./cadastro')
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!confirm) return

    const interval = setInterval(() => {
      setRedirectSeconds((current) => Math.max(current - 1, 0))
    }, 1000)
    const timeout = setTimeout(() => history.push('/concluir-cadastro'), 3000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [confirm, history])

  async function onSubmit() {
    setDisabled(true)

    if (!modalidade) {
      setModalidadeError(true)
      setTimeout(() => {
        setModalidadeError(false)
        setDisabled(false)
      }, 3000)
      return
    }

    if (senha !== confirmacaoSenha) {
      setValidarSenha(true)
      setTimeout(() => {
        setValidarSenha(false)
        setDisabled(false)
      }, 3000)
      return
    }

    if (!resultLocation?.latitude || !resultLocation?.longitude) {
      setErrorCep(true)
      setTimeout(() => {
        setErrorCep(false)
        setDisabled(false)
      }, 3000)
      return
    }

    const enviar = {
      cep: cep,
      rua: logradouro,
      cidade: cidade,
      bairro: bairro,
      estado: estado,
      numero: numero,
      senha: senha,
      nomeEmpresa: nomeEmpresa,
      cnpjOuCpf: cpfOuCnpj,
      latitude: resultLocation.latitude.toString(),
      longitude: resultLocation.longitude.toString(),
      modalidade: modalidade
    }

    rastrear('step2_submit')
    setWaiting(true)
    try {
      const response = await fetch('https://moovery.app/api/empresa/crm_passo2.php', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(enviar)
      })
      const data = await response.json().catch(() => null)

      if (response.ok && !data?.error && data?.data?.code === 201) {
        rastreio.concluir()
        rastrear('step2_success')
        setConfirm(true)
        setRedirectSeconds(3)
        localStorage.removeItem('CPFOUCNPJ')
        localStorage.removeItem('nomeCliente')
        return
      }

      rastrear('step2_error', { dados: { status: response.status } })
      mostrarErroCadastroFinal(data?.error?.message)
    } catch (error) {
      rastrear('step2_error', { dados: { status: 0 } })
      mostrarErroCadastroFinal()
    } finally {
      setWaiting(false)
    }
  }

  function mostrarErroCadastroFinal(mensagem) {
    setErrorCadastroFinal(mensagem || true)
    setTimeout(() => {
      setDisabled(false)
      setErrorCadastroFinal(false)
    }, 5000)
  }

  async function getCep(value) {
    setCep(value)
    try {
      const response = await fetch(`https://viacep.com.br/ws/${value}/json/`)
      const data = await response.json()

      setLogradouro(data.logradouro)
      setCidade(data.localidade)
      setBairro(data.bairro)
      setEstado(data.uf)

      verificaLatitudeLongitude({ cep: value }).then(setResultLocation)
    } catch (error) {
      setErrorCep(true)
      setTimeout(() => {
        setErrorCep(false)
      }, 3000)
    }
  }

  function abrirTermosDeUso() {
    window.open(
      'https://termos-de-uso-empresa.s3.us-east-2.amazonaws.com/termos_de_uso_da_plataforma_estabelecimentos_v2.1.0.pdf'
    )
  }

  function removeStorage() {
    localStorage.removeItem('CPFOUCNPJ')
    localStorage.removeItem('nomeCliente')

    history.push('./cadastro')
  }

  return (
    <>
      <Menu />
      {!abrirModalCadastro && <Modal nomeCliente={nomeLocal} onClick={removeStorage} />}
      {waiting === true && <AlertWaiting />}
      {errorCadastroFinal === true && (
        <AlertError>
          Ocorreu um erro inesperado <br /> entre em contato com o suporte
        </AlertError>
      )}
      {typeof errorCadastroFinal === 'string' && <AlertError>{errorCadastroFinal}</AlertError>}
      {errorCep === true && <AlertError> Por favor insira um cep valido</AlertError>}
      {confirm === true && (
        <Styled.Toast role="status" aria-live="polite">
          <Styled.ToastIcon>✔</Styled.ToastIcon>
          <div>
            <Styled.ToastTitle>Cadastro enviado com sucesso!</Styled.ToastTitle>
            <Styled.ToastDescription>
              Estamos finalizando tudo para você. Redirecionando em {redirectSeconds}s...
            </Styled.ToastDescription>
            <Styled.ToastProgress>
              <span style={{ width: `${(redirectSeconds / 3) * 100}%` }} />
            </Styled.ToastProgress>
          </div>
        </Styled.Toast>
      )}
      <Styled.Page>
        <Styled.Shell>
          <Styled.Card>
            <Styled.CardHeader>
              <div>
                <Styled.Badge>Passo 2 de 2</Styled.Badge>
                <TitleRoxo>Finalize o cadastro</TitleRoxo>
                <Styled.Subtitle>Endereço, localização e criação de acesso.</Styled.Subtitle>
              </div>
              <Styled.Stepper>
                <Styled.Step className="completed">
                  <Styled.StepIndex className="completed">1</Styled.StepIndex>
                  <Styled.StepLabel>
                    <strong>Dados iniciais</strong>
                    <span>Responsável e empresa</span>
                  </Styled.StepLabel>
                </Styled.Step>
                <Styled.Step className="active">
                  <Styled.StepIndex className="active">2</Styled.StepIndex>
                  <Styled.StepLabel>
                    <strong>Modalidade e acesso</strong>
                    <span>Modalidade, endereço e senha</span>
                  </Styled.StepLabel>
                </Styled.Step>
              </Styled.Stepper>
            </Styled.CardHeader>

            <Styled.ReviewStrip>
              <div>
                <span>Responsável</span>
                <strong>{nomeLocal || 'Responsável não informado'}</strong>
              </div>
              <div>
                <span>Documento</span>
                <strong>{cpfOuCnpj || 'CNPJ/CPF pendente'}</strong>
              </div>
            </Styled.ReviewStrip>

            <Styled.InputGroupEmpresa>
              <form onSubmit={handleSubmit(onSubmit, rastreio.registrarErros)} {...rastreio.handlers}>
                <Styled.FormGrid>
                  <Styled.InputField>
                    <label htmlFor="cep">CEP</label>
                    <input
                      {...register('cep', { required: true })}
                      placeholder="00000-000"
                      onBlur={(event) => getCep(event.target.value)}
                    />
                    {cep === '' && errors.cep && (
                      <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                    )}
                  </Styled.InputField>
                  <Styled.InputField>
                    <label htmlFor="bairro">Bairro</label>
                    <input
                      {...register('bairro')}
                      placeholder=""
                      onChange={(event) => {
                        setBairro(event.target.value)
                      }}
                      value={bairro}
                    />
                    {errors.cep && (
                      <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                    )}
                  </Styled.InputField>
                  <Styled.InputField>
                    <label htmlFor="cidade">Cidade</label>
                    <input
                      {...register('cidade')}
                      placeholder=""
                      onChange={(event) => {
                        setCidade(event.target.value)
                      }}
                      value={cidade}
                    />
                    {errors.cep && (
                      <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                    )}
                  </Styled.InputField>

                  <Styled.InputField>
                    <label htmlFor="rua">Rua</label>
                    <input
                      {...register('rua')}
                      value={logradouro}
                      onChange={(event) => setLogradouro(event.target.value)}
                      placeholder=""
                    />
                    {errors.rua && (
                      <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                    )}
                  </Styled.InputField>
                  <Styled.InputField>
                    <label htmlFor="estado">Estado</label>
                    <input
                      {...register('estado')}
                      value={estado}
                      onChange={(event) => setEstado(event.target.value)}
                      placeholder=""
                    />
                    {estado === '' && errors.estado && (
                      <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                    )}
                  </Styled.InputField>
                  <Styled.InputField>
                    <label htmlFor="numero">Numero</label>
                    <input
                      {...register('numero', { required: true })}
                      onChange={(event) => setNumero(event.target.value)}
                      placeholder="123"
                    />
                    {errors.numero && (
                      <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                    )}
                  </Styled.InputField>

                  <Styled.InputField className="full">
                    <label htmlFor="nomeEmpresa">Nome da empresa</label>
                    <input
                      {...register('nome_empresa', { required: true })}
                      onChange={(event) => setEmpresa(event.target.value)}
                      placeholder=""
                    />
                    {errors.nome_empresa && (
                      <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                    )}
                  </Styled.InputField>
                  <Styled.InputField>
                    <label htmlFor="senha">Senha</label>
                    <Styled.InputToggle>
                      <input
                        type={showSenha ? 'text' : 'password'}
                        {...register('senha', {
                          required: true,
                          minLength: {
                            value: 8,
                            message: 'A senha deve ter no mínimo 8 caracteres'
                          }
                        })}
                        onChange={(event) => setSenha(event.target.value)}
                        placeholder=""
                      />
                      <button type="button" onClick={() => setShowSenha((prev) => !prev)}>
                        {showSenha ? '🙈' : '👁'}
                      </button>
                    </Styled.InputToggle>
                    {errors.senha && <Styled.SpanError>{errors.senha.message}</Styled.SpanError>}
                  </Styled.InputField>
                  <Styled.InputField>
                    <label htmlFor="confirmacao_senha">Confirme sua senha</label>
                    <Styled.InputToggle>
                      <input
                        type={showConfirmacao ? 'text' : 'password'}
                        {...register('confirmacao_senha', {
                          required: true
                        })}
                        onChange={(event) => setConfirmacao(event.target.value)}
                        placeholder=""
                      />
                      <button type="button" onClick={() => setShowConfirmacao((prev) => !prev)}>
                        {showConfirmacao ? '🙈' : '👁'}
                      </button>
                    </Styled.InputToggle>
                    {errors.confirmacao_senha && (
                      <Styled.SpanError>Campo obrigatorio*</Styled.SpanError>
                    )}
                    {validarSenha && (
                      <Styled.SpanError>
                        A senha de confirmação deve ser igual a senha
                      </Styled.SpanError>
                    )}
                  </Styled.InputField>
                </Styled.FormGrid>

                <div style={{ marginTop: '1.5rem' }}>
                  <label style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1f2241', display: 'block', marginBottom: '0.75rem' }}>
                    Modalidade de operação
                  </label>
                  <div style={{
                    display: 'flex',
                    gap: '16px',
                    marginTop: '8px',
                    flexWrap: 'wrap'
                  }}>
                    <label
                      onClick={() => setModalidade('LOGISTICA')}
                      style={{
                        flex: 1,
                        minWidth: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        padding: '16px',
                        borderRadius: '10px',
                        border: modalidade === 'LOGISTICA'
                          ? '2px solid #7241a1'
                          : '2px solid #e0e0e0',
                        backgroundColor: modalidade === 'LOGISTICA'
                          ? '#f5f0fa'
                          : '#fff',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <input
                        type="radio"
                        name="modalidade"
                        value="LOGISTICA"
                        checked={modalidade === 'LOGISTICA'}
                        onChange={() => setModalidade('LOGISTICA')}
                        style={{ display: 'none' }}
                      />
                      <strong style={{
                        fontSize: '14px',
                        color: modalidade === 'LOGISTICA' ? '#7241a1' : '#333'
                      }}>
                        Logística Moovery + Própria
                      </strong>
                      <span style={{
                        display: 'block',
                        fontSize: '12px',
                        color: '#888',
                        marginTop: '4px',
                        lineHeight: '1.4'
                      }}>
                        Use nossa frota de entregadores na sua região, e gerencie a sua própria logística
                      </span>
                    </label>

                    {/* Opção: Logística Própria */}
                    <label
                      onClick={() => setModalidade('GERENCIAMENTO')}
                      style={{
                        flex: 1,
                        minWidth: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        padding: '16px',
                        borderRadius: '10px',
                        border: modalidade === 'GERENCIAMENTO'
                          ? '2px solid #7241a1'
                          : '2px solid #e0e0e0',
                        backgroundColor: modalidade === 'GERENCIAMENTO'
                          ? '#f5f0fa'
                          : '#fff',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <input
                        type="radio"
                        name="modalidade"
                        value="GERENCIAMENTO"
                        checked={modalidade === 'GERENCIAMENTO'}
                        onChange={() => setModalidade('GERENCIAMENTO')}
                        style={{ display: 'none' }}
                      />
                      <strong style={{
                        fontSize: '14px',
                        color: modalidade === 'GERENCIAMENTO' ? '#7241a1' : '#333'
                      }}>
                        Logística Própria
                      </strong>
                      <span style={{
                        display: 'block',
                        fontSize: '12px',
                        color: '#888',
                        marginTop: '4px',
                        lineHeight: '1.4'
                      }}>
                        Gerencie sua frota, roteirização, despacho e integrações com marketplaces usando nossa plataforma, sem usar nossos entregadores
                      </span>
                    </label>
                  </div>
                  {modalidadeError && (
                    <Styled.SpanError style={{ marginTop: '10px' }}>Selecione uma modalidade para continuar</Styled.SpanError>
                  )}
                </div>

                <Styled.Actions>
                  <p>
                    Ao clicar em Cadastre-se, você concorda com nossos{' '}
                    <Styled.A onClick={abrirTermosDeUso}>Termos de uso</Styled.A>.
                  </p>
                  <ButtonOrange type="submit" disabled={disabled}>
                    Concluir cadastro
                  </ButtonOrange>
                </Styled.Actions>
              </form>
            </Styled.InputGroupEmpresa>
          </Styled.Card>

          <Styled.SideCard>
            <Styled.SideBadge>Você está quase lá</Styled.SideBadge>
            <Styled.SideTitle>Próximos passos</Styled.SideTitle>
            <Styled.SideList>
              <li>Confirme o endereço com o CEP para carregarmos latitude e longitude.</li>
              <li>Crie uma senha forte para acessar o painel da Moovery.</li>
              <li>Revise os dados antes de concluir; você pode voltar ao passo anterior.</li>
              <li>Após concluir, mostraremos a confirmação e você será redirecionado.</li>
            </Styled.SideList>
          </Styled.SideCard>
        </Styled.Shell>
      </Styled.Page>
      <Footer />
    </>
  )
}
